<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex';

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
    },
    methods:{
        changePassword: function(){
            this.errors = [];
            this.messageIdToast = null;
            let state = this;

            state.data.password = state.newPassword;
            console.log(state.data)
            if(state.data){
                $('#spinner').modal('toggle');
                 Request.do(state,'PUT', Request.getDefaultHeader(state), state.data, `${Endpoints.systemUsers.systemUser}${state.data.email}`,
                (response)=>{//SUCCESS CALLBACK
                    $('#spinner').modal('toggle'); 
                    state.flashMessage.success(
                         state.configMessage(state.$t('string.msg.listUser.register.title.success'), state.$t('string.msg.listUser.register.message.success'), 'top left', 0, 630, 3000),
                        {
                            mounted: state.showText(state.$t('string.msg.listUser.register.message.success')),
                            destroyed: state.clearText()
                        }) 
                },
                (error)=>{//ERROR CALLBACK
                    console.log(error);
                });
            }
            
        },
         changeEmail: function(){
            this.errors = [];
            this.messageIdToast = null;
            let state = this;

            $('#spinner').modal('toggle');

            setTimeout(async function(){
            let response =  (await Request.do(state, 'PUT', Request.getDefaultHeader(state), {email: state.newEmail}, `${Endpoints.systemUsers.changeEmail}${state.data.email}`)).data;
            if (response && response.status==200){
                state.data.email = state.newEmail;
                $('#spinner').modal('toggle'); 
                state.flashMessage.success(
                        state.configMessage(state.$t('string.msg.listUser.register.title.success'), state.$t('string.msg.email.register.message.success'), 'top left', 0, 630, 3000),
                    {
                        mounted: state.showText(state.$t('string.msg.email.register.message.success')),
                        destroyed: state.clearText()
                    }) 
            }else{
                 $('#spinner').modal('toggle'); 
                 state.errors= [];
                state.errors.push(state.$t('response.user.email.already.use'));
            }

            }, 100);
        },
        changePhone: function(){
            this.errors = [];
            this.messageIdToast = null;
            let state = this;

             let data = JSON.parse(JSON.stringify(this.data));
            //  let data = JSON.parse(JSON.stringify(customer));
            if (data.price){
                data.price = data.price.toString().split(".").join("").split(",").join(".").split("R$ ").join("");
            }
            if(this.data.customerUser.dateBirth){
                let day,month,year;
                day = (this.data.customerUser.dateBirth.slice(0,2));
                month = (this.data.customerUser.dateBirth.slice(3,5));
                year = (this.data.customerUser.dateBirth.slice(6,10));

                data.customerUser.dateBirth = new Date();
                data.customerUser.dateBirth.setDate(day);
                data.customerUser.dateBirth.setMonth(month-1);
                data.customerUser.dateBirth.setFullYear(year);
            }
            
            data.primaryPhone = state.newPhone;


            let formData = new FormData();

            formData.append('file', this.file);
            formData.append('jsonData', JSON.stringify(data));

            $('#spinner').modal('toggle');

            setTimeout(async function(){
            let ok = (await Request.do(state, 'POST', Request.getDefaultHeader(state), {primaryPhone: state.newPhone}, `${Endpoints.systemUsers.checkPhone}`));
                if (ok && ok.status!=200){
                    console.log("passou2")
                    let response = (await Request.do(state, 'PUT', Request.getDefaultHeader(state), formData, `${Endpoints.systemUsers.systemUserFormdata}${state.data._id ? state.data.email : ''}`)).data;
                    console.log(state.data)
                    if (response && response.status==200){
                        console.log("passou3")
                        state.data.phone = state.newPhone;
                        $('#spinner').modal('toggle'); 
                        state.flashMessage.success(
                            state.configMessage(state.$t('string.msg.listUser.register.title.success'), state.$t('string.msg.phone.register.message.succes'), 'top left', 0, 630, 3000),
                        {
                            mounted: state.showText(state.$t('string.msg.phone.register.message.succes')),
                            destroyed: state.clearText()
                        }) 
                    }
                    else{
                        $('#spinner').modal('toggle'); 
                        state.errors= [];
                    }
                }
                else{
                     $('#spinner').modal('toggle'); 
                        state.errors= [];
                        state.errors.push(state.$t('response.user.phone.already.use'));
                }
            }, 100);
        },
        checkForm: function (e) {
            this.errors = [];
            if (!this.newPassword) {
                this.errors.push(this.$t('response.user.register.new.password.required'));
            }
             if (this.newPassword.length < 6) {
                this.errors.push(this.$t('response.user.register.new.password.length.required'));
            }
            if (this.errors.length>0){
                e.preventDefault();
            }else{
                this.changePassword();
            }
        },
        checkFormEmail: function (e) {
            this.errors = [];
            if (!this.newEmail) {
                this.errors.push(this.$t('response.user.register.new.email.required'));
            }
             if (this.newEmail.length < 6 && this.newEmail.includes("@")) {
                this.errors.push(this.$t('response.user.register.new.email.length.required'));
            }
            if (this.errors.length>0){
                e.preventDefault();
            }else{
                this.changeEmail();
            }
        },
        checkFormPhone: function (e) {
            this.errors = [];
            if (!this.newPhone) {
                this.errors.push(this.$t('response.user.register.phone.required'));
            }
            if (this.errors.length>0){
                e.preventDefault();
            }else{
                this.changePhone();
                console.log("passou")
            }
        },
        selectItem: function(item){
            this.data = JSON.parse(JSON.stringify(item));

            if(this.data.type == 'USER-CUSTOMER'){
                Request.do(this, 'POST', Request.getDefaultHeader(this), {systemUser:this.data._id}, `${Endpoints.trucks.listByType}`,
                (response)=>{//SUCCESS CALLBACK
                   this.trucks = response.results;
                },
                (error)=>{//ERROR CALLBACK
                return null;
                });

            }
            // console.log(this.data);
            console.log(this.data);
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },
        clearForm: function(){
          this.company = "";
          this.data = {};
        },
        showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout( () => this.text = '', 500);
        },
        configMessage :function(title, message, position, x, y, time){
            const config ={
               title: title,
                message: message,
                position: position,
                x: x,
                y: y,
                time: time
            }
            return config
        },
         camelize: Common.camelize,
         toUpperCase: Common.toUpperCase,
    }
}
</script>
